import PolicyLayout, { Section } from "../../components/public/PolicyLayout";
import { EnvelopeSimple, MapPin, Buildings, Clock, Phone } from "@phosphor-icons/react";
import { pushEvent, currentPagePath } from "../../lib/analytics";

function Row({ icon: Icon, label, children, testid }) {
  return (
    <div className="flex items-start gap-3" data-testid={testid}>
      <span className="grid place-items-center w-9 h-9 bg-[hsl(var(--surface))] border rounded-[2px] text-[hsl(var(--foreground))] shrink-0">
        <Icon size={16} weight="bold" />
      </span>
      <div>
        <div className="overline mb-0.5">{label}</div>
        <div className="text-[15px] text-[hsl(var(--foreground))] leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

export default function Contact() {
  return (
    <PolicyLayout
      title="Contact Us"
      subtitle="Reach the Air12 team for pricing, shipments, and support."
      testid="contact-page"
    >
      <div className="grid-card p-6 space-y-5">
        <Row icon={EnvelopeSimple} label="Email" testid="contact-email">
          <a href="mailto:info@air12.in" className="hover:text-[hsl(var(--accent))]">info@air12.in</a>
        </Row>
        <Row icon={Buildings} label="Legal entity" testid="contact-entity">
          Ascribe Attributions Systems Private Limited
        </Row>
        <Row icon={MapPin} label="Registered office" testid="contact-address">
          Lightbridge, 6th Flr, Powai, Hiranandani Business Park, Mumbai 400072
        </Row>
        <Row icon={Clock} label="Business hours" testid="contact-hours">
          09:00 IST to 21:00 IST
        </Row>
        <Row icon={Phone} label="Phone" testid="contact-phone">
          <a href="tel:+919004846536" className="hover:text-[hsl(var(--accent))]" onClick={() => pushEvent("phone_click", { page_path: currentPagePath(), placement: "contact_page", cta_name: "phone_click" })}>+919004846536</a>
        </Row>
      </div>
      <Section>
        <p>For shipment-specific queries, please include your Air12 shipment code so we can assist you faster.</p>
      </Section>
    </PolicyLayout>
  );
}
